// extracted by mini-css-extract-plugin
export default {"active":"Sidebar_active__hBEfB","inactive":"Sidebar_inactive__3zZZ8","navIcon":"Sidebar_navIcon__4PzX9","navBtn":"Sidebar_navBtn__arRlE"};